import { render, staticRenderFns } from "./QuoteDraftStateCard.vue?vue&type=template&id=a0aa9358&"
import script from "./QuoteDraftStateCard.vue?vue&type=script&lang=ts&"
export * from "./QuoteDraftStateCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports